const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/raw-footage/organizations/$organizationId/index.tsx?tsr-split=component');
const $$splitErrorComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/raw-footage/organizations/$organizationId/index.tsx?tsr-split=errorComponent');
import { lazyRouteComponent } from '@tanstack/react-router';
import { requireCapabilities } from '@/features/authentication/lib/routeGuards';
import { organizationProjectsInfiniteQuery, organizationQuery } from '@/features/organization-project-picker/services/organizationProjectQueries';
import { OrganizationProjectsSkeleton } from '@/features/raw-footage/components/OrganizationProjectsSkeleton';
import { createFileRoute } from '@tanstack/react-router';

/**
 * Organization projects. The loader prefetches the org and its projects into the
 * query cache, so this route owns the loading skeleton (`pendingComponent`) and
 * error UI (`errorComponent`); `OrganizationProjectsView` reads from that warm
 * cache.
 *
 * This is an index route (`.../organizations/$organizationId/`) so it stays a
 * sibling of the nested `projects/$projectId` route rather than its layout — the
 * project page renders in the raw-footage outlet, not inside this one.
 */
export const Route = createFileRoute('/_authenticated/_app/raw-footage/organizations/$organizationId/')({
  beforeLoad: requireCapabilities(has => has('projects.list')),
  loader: ({
    context,
    params
  }) => Promise.all([context.queryClient.ensureQueryData(organizationQuery(params.organizationId)), context.queryClient.ensureInfiniteQueryData(organizationProjectsInfiniteQuery(params.organizationId))]),
  pendingComponent: () => <div className="flex flex-1 flex-col p-6">
      <OrganizationProjectsSkeleton />
    </div>,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});